module.exports = __webpack_public_path__ + "static/media/company.27164e79.svg";